import { setLocalStorageAuth } from "Utils";

const initialState = {
  fetching: false,
  fetched: false,
  updated: false,
  updating: false,
  token: "",
  expiresIn: null,
  createdAt: null,
  user: null,
  error: null,
  loggedAs: "GUEST",
  spaceAs: "MANAGER",
  preferences: [],
  loggedAsPost: null,
  currentOrganization: null,
  withoutHeader: false,
  withoutMenu: false,
  partnerOptions: [],
  partner: null,
  partnerZone: null
};

export const authReducer = (state = initialState, action) => {
  let result = { ...state };

  switch (action.type) {
    case "SET_AUTH": {
      result = action.auth == null ? { ...initialState } : { ...action.auth };
      break;
    }
    case "SET_AUTH_USER": {
      result = { ...state, user: action.user };
      break;
    }
    case "SET_AUTH_TOKEN": {
      result = { ...state, token: action.token };
      break;
    }
    case "SET_CURRENT_ORGANIZATION_PENDING": {
      result = { ...state, updating: true, updated: false };
      break;
    }
    case "SET_CURRENT_ORGANIZATION_FULFILLED": {
      let loggedAs = "GUEST";
      let userType = state.user.type;
      let currentOrganization = Object.assign({}, action.payload);
      if (
        currentOrganization &&
        currentOrganization["authorisation"] &&
        currentOrganization["authorisation"].role
      ) {
        loggedAs = currentOrganization["authorisation"].role;
      }
      currentOrganization.userType = userType;
      result = {
        ...state,
        loggedAs,
        updating: false,
        updated: true,
        preferences:
          (currentOrganization["authorisation"] &&
            currentOrganization["authorisation"].preferences) ||
          [],
        currentOrganization: currentOrganization
      };
      break;
    }
    case "SET_CURRENT_ORGANIZATION_REJECTED": {
      let error = action.payload;
      switch (error && error.response && error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      result = {
        ...state,
        updating: false,
        updated: false,
        error
      };
      break;
    }
    case "SET_EXPIRES_IN": {
      result = { ...state, expiresIn: action.expiresIn };
      break;
    }
    case "SET_TOKEN_CREATED_AT": {
      result = { ...state, createdAt: action.createdAt };
      break;
    }
    case "SET_AUTH_LOGGED_AS": {
      result = { ...state, loggedAs: action.loggedAs };
      break;
    }
    case "SET_AUTH_LOGGED_AS_POST": {
      result = { ...state, loggedAsPost: action.loggedAsPost };
      break;
    }
    case "FETCH_AUTH_USER_PENDING": {
      result = { ...state, fetching: true };
      break;
    }
    case "FETCH_AUTH_USER_FULFILLED": {
      let user = action.payload;
      user["communities"] = user.userOrganizations;

      let loggedAs = state.loggedAs;
      let preferences = [];

      let { userOrganizations } = user;
      let currentOrganization = null;
      if (userOrganizations && userOrganizations.length) {
        currentOrganization = userOrganizations.filter(
          ({ isSelected }) => isSelected
        )[0];
      }

      if (currentOrganization && currentOrganization["authorisation"]) {
        loggedAs = currentOrganization["authorisation"].role || loggedAs;
        preferences = currentOrganization["authorisation"].preferences || [];
      }

      result = {
        ...state,
        fetching: false,
        fetched: true,
        user: user,
        currentOrganization,
        preferences,
        loggedAs
      };
      break;
    }
    case "FETCH_AUTH_USER_REJECTED": {
      result = {
        ...state,
        fetching: false,
        error: action.payload
      };
      break;
    }
    case "SET_SWITCH_SPACE": {
      result = { ...state, spaceAs: action.typeUser };
      break;
    }
    case "SET_WITH_OUT_HEADER": {
      result = { ...state, withoutHeader: action.withoutHeader };
      break;
    }
    case "SET_WITHOUT_MENU": {
      result = { ...state, withoutMenu: action.withoutMenu };
      break;
    }
    case "SET_PARTNER_OPTIONS": {
      result = {
        ...state,
        fetching: false,
        fetched: true,
        partnerOptions: action.partners
      };
      break;
    }
    case "SET_PARTNER": {
      result = {
        ...state,
        partner: action.partner
      };
      break;
    }
    case "SET_PARTNER_ZONE": {
      result = {
        ...state,
        partnerZone: action.zone
      };
      break;
    }
    default:
      return state;
  }

  setLocalStorageAuth(result);

  return result;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js